
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class HomeMainVisual extends Vue {
  private name = 'HomeMainVisual';
}
